export const LOGGER_MESSAGES = {
    PV: "ページ表示",
    CLICK_ENTER_ROOM: "入室ボタン押下",
    CHECK_LESSON_INFO: "レッスン情報確認",
    ENTRY_BUTTON_STATE_CHANGE: "入室ボタン活性状態変化"
} as const